import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const UserIconOutline = createIcon({
  displayName: 'UserIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M20,20v-.75A4.25,4.25,0,0,0,15.75,15H8.25A4.25,4.25,0,0,0,4,19.25V20"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        xmlns="http://www.w3.org/2000/svg"
        cx="12"
        cy="7"
        r="4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const UserIconTwoTone = createIcon({
  displayName: 'UserIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="path"
        xmlns="http://www.w3.org/2000/svg"
        d="M20,20v-.75A4.25,4.25,0,0,0,15.75,15H8.25A4.25,4.25,0,0,0,4,19.25V20"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        xmlns="http://www.w3.org/2000/svg"
        cx="12"
        cy="7"
        r="4"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="rect" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const User: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={UserIconTwoTone} {...props} />

  return <CustomIcon as={UserIconOutline} {...props} />
}

export default memo(User)
